import InputSelection from '@ott/input-selection';

const { getSelection, setSelection } = InputSelection;

const isAndroid = /Android/i.test(typeof navigator !== 'undefined' && navigator.userAgent);

export function getCursonPosition(inputRef) {
  return getSelection(inputRef.current).end;
}

export function calcCursorPosition(inputValue, prevValue, formattedResult) {
  // если после изменения символов строка сформатиловалась как и была
  // то просто передвигаем курсор на кол-во измененных символов
  let { cursor } = formattedResult;
  const lengthDiff = inputValue.length - formattedResult.value.length;

  if (lengthDiff < 0) {
    if (cursor && prevValue === formattedResult.value) {
      cursor += lengthDiff;
    }
  } else if (lengthDiff > 0) {
    if (!cursor && prevValue === formattedResult.value) {
      cursor -= lengthDiff;
    }
  }

  return cursor;
}

export function moveCursorPosition(inputRef, cursorPosition) {
  setSelection(inputRef.current, { start: cursorPosition, end: cursorPosition });
}
